import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = ["action"];
var _hoisted_2 = ["name", "value"];
var _hoisted_3 = { class: "base-model__content" };
var _hoisted_4 = { class: "base-model__header" };
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "base-model__header-title heading-h5" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "icon icon-alert-circle-colour icon--xs",
        "aria-hidden": "true"
    }),
    /*#__PURE__*/ _createTextVNode(" Important Information ")
], -1 /* HOISTED */);
var _hoisted_6 = ["onClick"];
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-close icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_8 = [
    _hoisted_7
];
var _hoisted_9 = { class: "base-model__body" };
var _hoisted_10 = { class: "rte" };
var _hoisted_11 = { class: "base-model__footer" };
var _hoisted_12 = ["onClick"];
import { computed, inject, ref } from 'vue';
import BaseModal from '../BaseModal/BaseModal.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AmadeusFormSubmission',
    props: {
        params: {},
        refx: { type: Boolean },
        url: {}
    },
    emits: ["onSubmit"],
    setup: function (__props, _a) {
        var _b;
        var emit = _a.emit;
        var props = __props;
        var form = ref(null);
        var alertModal = ref(null);
        var state = (_b = inject('preferences')) !== null && _b !== void 0 ? _b : {};
        var amadeusOverrideActionUrl = inject('amadeus-override-action-url');
        var refxBookingUrl = inject('amadeus-refx-booking-url');
        var destinationAlerts = inject('destination-alerts');
        var useRefx = computed(function () { return !!props.refx; });
        var currentAlert = ref(null);
        var showAlertModal = function (alert) {
            var _a;
            currentAlert.value = alert;
            // @ts-ignore
            (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal();
        };
        var onContinue = function () {
            var _a, _b;
            // @ts-ignore
            (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.closeModal();
            (_b = form.value) === null || _b === void 0 ? void 0 : _b.submit();
            currentAlert.value = null;
            emit('onSubmit', undefined);
        };
        var onSubmit = function (event) {
            var _a;
            var search = JSON.parse(props.params.search);
            var itineraries = (_a = search === null || search === void 0 ? void 0 : search.itineraries) !== null && _a !== void 0 ? _a : [];
            if (itineraries.length > 0) {
                for (var _i = 0, destinationAlerts_1 = destinationAlerts; _i < destinationAlerts_1.length; _i++) {
                    var alert = destinationAlerts_1[_i];
                    // Only check the first itinerary (outbound leg) for destination alerts
                    var firstItinerary = itineraries[0];
                    if (alert.destination === firstItinerary.destinationLocationCode &&
                        (!alert.origin || alert.origin === firstItinerary.originLocationCode) &&
                        alert.message &&
                        currentAlert.value !== alert) {
                        event.preventDefault();
                        showAlertModal(alert);
                        return;
                    }
                }
            }
            currentAlert.value = null;
            emit('onSubmit', event);
        };
        var bookingUrlWithLang = computed(function () {
            var _a, _b, _c;
            if (useRefx.value) {
                return props.url
                    ? props.url
                    : "".concat(refxBookingUrl, "?lang=").concat((_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.language) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.substring(0, 2)) !== null && _c !== void 0 ? _c : 'en');
            }
            return amadeusOverrideActionUrl;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("form", {
                ref_key: "form",
                ref: form,
                action: bookingUrlWithLang.value,
                onSubmit: onSubmit,
                method: "POST"
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.params), function (key) {
                    return (_openBlock(), _createElementBlock("input", {
                        key: key,
                        name: key,
                        value: _ctx.params[key],
                        type: "hidden"
                    }, null, 8 /* PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */)),
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(BaseModal, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, {
                    "modal-content": _withCtx(function (_a) {
                        var _b;
                        var closeModal = _a.closeModal;
                        return [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _hoisted_5,
                                    _createElementVNode("button", {
                                        role: "button",
                                        "aria-label": "Dismiss modal",
                                        class: "button--text button--icon base-model__header-close",
                                        onClick: function () {
                                            closeModal();
                                        }
                                    }, _hoisted_8, 8 /* PROPS */, _hoisted_6)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("p", null, _toDisplayString((_b = currentAlert.value) === null || _b === void 0 ? void 0 : _b.message), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("button", {
                                        class: "button button--text",
                                        onClick: closeModal
                                    }, " Cancel ", 8 /* PROPS */, _hoisted_12),
                                    _createElementVNode("button", {
                                        class: "button button--primary",
                                        onClick: onContinue
                                    }, " Okay ")
                                ])
                            ])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1));
        };
    }
});
